<template>
  <div>
    <el-row :gutter="50" v-if="position == 'left'">
      <el-col :span="12" :offset="0">
        <el-image style="width: 100%; height: 500px" :src="article.image" fit="cover"></el-image>
      </el-col>
      <el-col :span="12" :offset="0">
        <h3 class="sec-title">{{article.title}}</h3>
        <div class="sec-des">
          {{article.des}}
        </div>
        <div v-if="goodsIncludes !== undefined">
          <div class="includes-title">以下产品系列中均含有：</div>
          <div v-for="(goods, index) in goodsIncludes" :key="index" class="goods">· {{goods}}</div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="50" v-else>
      <el-col :span="12" :offset="0">
        <h3 class="sec-title">{{article.title}}</h3>
        <div class="sec-des">
          {{article.des}}
        </div>
        <div v-if="goodsIncludes !== undefined">
          <div class="includes-title">以下产品系列中均含有：</div>
          <div v-for="(goods, index) in goodsIncludes" :key="index" class="goods">· {{goods}}</div>
        </div>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-image style="width: 100%; height: 450px" :src="article.image" fit="cover"></el-image>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: 'left'
    },
    article: Object,
    goodsIncludes: Array
  }
}
</script>

<style scoped>
.sec-title{
  color: #303133;
  font-size: 21px;
  line-height: 33px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin: 0px 0 20px;
  padding: 5px 15px;
  background-color: #ACE1E2;
  display: inline-block;
  border-radius: 5px;
}
.sec-des{
  color: #505050;
  font-size: 17px;
  font-weight: 300;
  line-height: 30px;
  text-align: justify;
}
.includes-title{
  padding: 30px 0 20px;
  font-size: 15px;
  font-weight: bold;
}
.goods{
  line-height: 25px;
  font-size: 15px;
}
</style>
